<h1 class="setting-title" i18n="@@settings_legals_title">Legal notice</h1>
<p i18n="@@settings_legals_description">
  If you have any questions and wish to exercise your right regarding your
  personal data, our team is available to answer you.
</p>
<p class="link-pdf">
  <a
    href="mailto:privacy@nmosdopilot.com"
    class="link justify-content-start fw-semi-bold"
  >
    <img class="icon-document" src="assets/icons/icon-mail.svg" alt="doc" />
    privacy@adscientiam.com
  </a>
</p>
<h3
  class="mb-3 subtitle-setting"
  i18n="@@settings_legals_DocumentationSubtitle"
>
  Documentation
</h3>
<p class="link-pdf">
  <a
    [href]="'assets/documents/privacy-policy-' + link_lang + '.pdf'"
    class="link justify-content-start fw-semi-bold"
  >
    <img class="icon-document" src="assets/icons/icon-document.svg" alt="doc" />
    <span i18n="@@settings_legals_refererToDataProcessingPolicy"
      >Consult the data processing policy</span
    ></a
  >
</p>
<h3 class="mb-3 subtitle-setting" i18n="@@settings_legals_aboutSubtitle">
  About
</h3>
<div class="etiquette mw-100">
  <p class="title" i18n="@@settings_legals_etiquetteTitle">
    Dashboard NMOSD Copilot®
  </p>
  <p class="subtitle">
    <img class="img-right" src="assets/img/logo-ref.svg" alt="ref" />
    <span i18n="@@settings_legals_etiquetteSubtitle">DA304-DASHBOARD</span>
  </p>
  <img class="logo" src="assets/img/nmosd-logo-etiquette.svg" alt="logo" />
  <p class="subtitle">
    <span i18n="@@settings_legals_etiquetteVersion">Version </span>
    {{ version }}
  </p>
  <p class="">
    <span i18n="@@settings_legals_etiquetteWarning">Warning</span>
  </p>
  <p><img src="assets/img/logo-fabricant.svg" alt="logo" /></p>
  <p class="address" i18n="@@settings_legals_etiquetteAddress">
    Ad Scientiam SAS<br />
    21-23 rue Albert Bayet - 75103 Paris - FR<br />
    +33 (0)1 57 27 41 94
  </p>
  <div class="udi">
    <img src="assets/img/logo-udi.svg" alt="udi" />
    (01)3770027067054(8012){{ version }}
  </div>
  <div class="footer">
    <p class="icons-right">
      <img class="img-right" src="assets/img/logo-md-cc.svg" alt="cc" />
      <span i18n="@@settings_legals_etiquetteDate">2022-09</span>
    </p>
    <p class="icons-right">
      <img class="img-right" src="assets/img/logo-caution.svg" alt="logo" />
      <img class="img-right big" src="assets/img/e-ifu-logo-2.svg" alt="ifu" />
      <img class="img-right big" src="assets/img/logo-md.svg" alt="md" />
    </p>
  </div>
  <div class="right-label">
    <span i18n="@@settings_legals_labelForHcp"
      >DA304 Label for HCP FR(FR) 20230821</span
    >
  </div>
</div>
